<template>
    <section class="admin container">
        <div class="row">
            <h3>Admin</h3>
            <div class="col-12 justify-content-center">
                <a v-bind:href="publicKeyUrl" class="btn btn-primary" role="button">Descargar llave publica</a>
                <a v-bind:href="privateKeyUrl" class="btn btn-primary" role="button">Descargar llave privada</a>
            </div>
        </div>
    </section>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/app'
import 'firebase/auth'
const openpgp = require("openpgp")

export default {
    data() {
        return {
            userId: null,
            configData: {},
            privateKeyUrl: null,
            publicKeyUrl: null,
            revocationUrl: null
        };
    },
    created() {
        this.getCurrentUser()
        this.getKeys()
    },
    methods: {
        async getCurrentUser() {
            const admins = ["izaruz@gmail.com"];
            if (!admins.includes(firebase.auth().currentUser.email)) {
                this.$router.push({ name: 'Dashboard' })
            }
            this.userId = await firebase.auth().currentUser.uid
        },
        async getKeys() {
            let currentKeys = {}
            let configRef = await firebase.firestore().collection("config").doc('general2020')
            let storage = firebase.storage();
            let storageSigRef = storage.ref('config')

            let doc = await configRef.get()
            if (!doc.exists) {
                currentKeys.privateKey = ""
                currentKeys.publicKey = ""
                currentKeys.revocationCertificate = ""
            }

            if (doc.data().privateKey && doc.data().publicKey && doc.data().revocationCertificate) {
                currentKeys.privateKey = doc.data().privateKey
                currentKeys.publicKey = doc.data().publicKey
                currentKeys.revocationCertificate = doc.data().revocationCertificate
            } else {
                const { privateKeyArmored, publicKeyArmored, revocationCertificate } = await openpgp.generateKey({ curve: 'ed25519',  userIds: [{ name: 'Universidad Galileo', email: 'ayudages@galileo.edu' }], passphrase: doc.data().passphrase })
                // Save keys data
                configRef.update({'privateKey': privateKeyArmored})
                configRef.update({'publicKey': publicKeyArmored})
                configRef.update({'revocationCertificate': revocationCertificate})
                // Generate keys docs
                storageSigRef.child('privateKey.sig').putString(privateKeyArmored)
                storageSigRef.child('publicKey.sig').putString(publicKeyArmored)
                storageSigRef.child('revocationCertificate.sig').putString(revocationCertificate)

                currentKeys.privateKey = privateKeyArmored
                currentKeys.publicKey = publicKeyArmored
                currentKeys.revocationCertificate = revocationCertificate
            }
            
            let privateKeyRef = await storageSigRef.child('privateKey.sig').getDownloadURL()
            let publicKeyRef = await storageSigRef.child('publicKey.sig').getDownloadURL()
            let revocationRef = await storageSigRef.child('revocationCertificate.sig').getDownloadURL()

            this.privateKeyUrl = privateKeyRef
            this.publicKeyUrl = publicKeyRef
            this.revocationUrl = revocationRef
            this.configData = currentKeys
            return currentKeys
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Admin.vue